import { useState } from 'react'

import { CostCenter } from 'InstitutionalManagement/types'
import getCostCenterOnCustomForm from './services/getCostCenterOnCustomForm'

export default function useGetCostCenterByID() {
  const [loadingCostCenter, setLoadingCostCenter] = useState<boolean>(false)
  const [costCenter, setCostCenter] = useState<CostCenter>({})

  async function getCostCenter(costCenterId?: string) {
    setLoadingCostCenter(true)
    const response = await getCostCenterOnCustomForm({ costCenterId: costCenterId as string })
    let costCenterFromAPI: CostCenter = {}
    if (response?.header?.success) {
      costCenterFromAPI = response?.body?.cost_center
      setCostCenter(costCenterFromAPI)
    }
    setLoadingCostCenter(false)
    return costCenterFromAPI
  }

  return { getCostCenter, costCenter, loadingCostCenter }
}
